class Logger {
  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development' || process.env.ENVIRONMENT === 'dev';
  }

  log(...args) {
    if (this.isDevelopment) {
      console.log('[LOG]', ...args);
    }
  }

  info(...args) {
    if (this.isDevelopment) {
      console.info('[INFO]', ...args);
    }
  }

  warn(...args) {
    if (this.isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  }

  error(...args) {
    if (this.isDevelopment) {
      console.error('[ERROR]', ...args);
    }
  }

  debug(...args) {
    if (this.isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  }

  group(label) {
    if (this.isDevelopment) {
      console.group(label);
    }
  }

  groupEnd() {
    if (this.isDevelopment) {
      console.groupEnd();
    }
  }

  table(data) {
    if (this.isDevelopment) {
      console.table(data);
    }
  }
}

// Create and export a singleton instance
const logger = new Logger();
export default logger;